import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Periodos';

export interface Periodo{
	año: number;
	periodo: number;
	reunion: string;
	estado: string;
    comentarios: string;
    fDesde: any;
    fHasta: any;
	contenidos: any[];
	mesCambio: number;
}
export interface ContenidoPeriodo{
	idTipoPeriodo: number;
	idTipoContenido: string;
	tipoContenido: string;
	idVersion?: number;
}

export interface InformePeriodo{
	idTipoPeriodo: number;
	idTipoInforme: string;
	tipoInforme: string;
}

export interface PeriodoDescripciones {
    idTipoPeriodo: number;
    tipoPeriodo: string;
}

export interface TipoContenidoPeriodo {
    idTipoContenido: string;
    tipoContenido: string;
}

export interface PeriodoContenidoEntity
{
    idTipoContenido: string,
    tipoContenido: string,
    idVersion: number
}
export interface AñoPeriodoEntity
{
    año: number;
    periodo: number;
}
export interface InformeEntity{
    idTipoInforme: string;
    tipoInforme: string;
}

export interface AñoPeriodoEntity
{
	año: number;
	periodo: number;
}

export interface InformeEntity{
	idTipoInforme: string;
	tipoInforme: string;
}

export class PeriodosAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarPeriodos(ejercicio: number): AxiosPromise<Periodo[]> {
		return this.cliente.get(`/ListarPeriodos/${ejercicio}`);
	}

    ListarPeriodosDescripciones(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarPeriodosDescripciones`);
	}

	ListarTiposContenidoPeriodo(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarTiposContenidoPeriodo`);
	}

	ListarContenidosPeriodo(periodo?: number, año?: number):AxiosPromise<any[]> {
		return this.cliente.get(`/ListarContenidosPeriodo/${periodo}/${año}`);
	}

	ListarInformesPeriodo(periodo?: number, año?: number):AxiosPromise<any[]> {
		return this.cliente.get(`/ListarInformesPeriodo/${periodo}/${año}`);
	}

	CrearPeriodo(periodo:Periodo): AxiosPromise<Periodo[]> {
		return this.cliente.post(periodo, `/CrearPeriodo`);
	}
	
	EliminarPeriodo(periodo:number, año:number): AxiosPromise<any> {
		return this.cliente.removeVarious(periodo, año, `/EliminarPeriodo`);
	}

	ListarInformesAñoPeriodo(data: AñoPeriodoEntity):AxiosPromise<any[]> {
		return this.cliente.post(data, `/ListarInformesAñoPeriodo`);
	}

	ModificarPeriodo(updateData: Periodo): AxiosPromise<Periodo[]> {
		return this.cliente.put('', updateData,`/ModificarPeriodo`);
	}

	ModificarEstadoPeriodo(updateData: Periodo, nuevoEstado: string): AxiosPromise<Periodo[]> {
		return this.cliente.put(nuevoEstado, updateData,`/ModificarEstadoPeriodo`);
	}

	getTiposContenidoUltimoPeriodoCerrado(): AxiosPromise<any[]> {
        return this.cliente.get(`/ListarTiposContenidoUltimoPeriodoCerrado`);
    }
    getTiposContenidoPeriodoAbierto(): AxiosPromise<any[]> {
        return this.cliente.get(`/ListarTiposContenidoPeriodoAbierto`);
    }

	GetMinMaxEjercicio() : AxiosPromise<any[]>{
		return this.cliente.get(`/GetMinMaxEjercicio`);
	}

	ListarPeriodosEjercicio(data:any) :AxiosPromise<any[]> {
		return this.cliente.post(data, `/ListarPeriodosEjercicio`);
	}

	ListarInformesExcel() : AxiosPromise<any[]> {
		return this.cliente.get(`/ListarInformesExcel`);
	}

	ListarTiposContenido(año:number, periodo:number): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarTiposContenido/${año}/${periodo}`);
	}
}